<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-row no gutter>
          <v-col cols="12" sm="2" md="2">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="400px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateFormatted"
                  required
                  :rules="dateRules"
                  prepend-icon="event"
                  v-on="on"
                  @blur="start_date = parseDate(startDateFormatted)"
                  label="From Date"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="start_date"
                no-title
                @input="getPositions()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="400px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateFormatted"
                  required
                  :rules="dateRules"
                  prepend-icon="event"
                  v-on="on"
                  @blur="end_date = parseDate(endDateFormatted)"
                  label="To Date"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="end_date"
                no-title
                @input="getPositions()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              v-model="pf_enter_speed"
              label="Max Enter Speed"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              v-model="pf_distance_min"
              label="Min PF Lenght"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              v-model="pf_distance_max"
              label="Max PF Lenght"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="createCSV()">
              <v-icon left dark>mdi-download</v-icon>Dnload csv
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="createPDF()">
              <v-icon left dark>mdi-download</v-icon>Dnload PDF
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="getPositions()">
              <v-icon left dark>mdi-refresh</v-icon>Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :fixed-header="true"
        :items="positions"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 100],
        }"
        :items-per-page="40"
        item-key="id"
        @click:row="onRowClick($event)"
        class="elevation-1"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :mobile-breakpoint="100"
      >
        <template v-slot:item.train_date="{ item }">
          {{ getFormattedDate(item.train_date) }}
        </template>
        <template v-slot:item.arr="{ item }">
          {{ getFormattedTime(item.arr) }}
        </template>
        <template v-slot:item.dep="{ item }">
          {{ getFormattedTime(item.dep) }}
        </template>
        <template v-slot:item.name="{ item }">
          <span v-if="item.name">{{
            item.name + " (" + item.s_org + " - " + item.s_dest + ")"
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsonexport from "jsonexport/dist";
import { saveAs } from "file-saver";
import { mapState, mapGetter, mapActions } from "vuex";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
export default {
  name: "pf_enter_high",
  data() {
    return {
      csvurl: null,
      errors: [],
      headers: [
        {
          text: "Train Date",
          align: "left",
          sortable: true,
          value: "train_date",
        },
        {
          text: "Train No.",
          align: "left",
          sortable: true,
          value: "train_no",
        },
        {
          text: "Org.",
          align: "left",
          sortable: true,
          value: "org",
        },
        {
          text: "Dep",
          sortable: false,
          value: "dep",
        },
        {
          text: "Dest.",
          align: "left",
          sortable: true,
          value: "dest",
        },
        {
          text: "Arr",
          sortable: false,
          value: "arr",
        },
        {
          text: "Unit No.",
          align: "left",
          sortable: true,
          value: "device_name",
        },
        {
          text: "Staion",
          align: "left",
          sortable: false,
          value: "stn_code",
        },
        {
          text: "Stop at",
          sortable: false,
          value: "act_arr",
        },
        {
          text: "PF Distance",
          value: "pf_distance",
        },
        {
          text: "PF enter speed",
          value: "pf_enter_speed",
        },
        {
          text: "Crew Name",
          value: "name",
        },
        {
          text: "CLI Name",
          value: "Name",
        },
      ],
      position: {},
      positions: [],
      search: "",
      dateRules: [(v) => !!v || "Date is required"],
      start_date:
        this.curStartDate || moment().format("YYYY-MM-DD"),
      end_date: this.curEndDate || moment().format("YYYY-MM-DD"),
      startDateFormatted:
        this.curStartDate || moment().format("DD/MM/YYYY"),
      endDateFormatted: this.curEndDate || moment().format("DD/MM/YYYY"),
      menu1: false,
      menu2: false,
      pf_enter_speed: 45,
      pf_distance_min: 260,
      pf_distance_max: 300,
      isLoading: false,
    };
  },
  created() {
    (this.start_date = this.curStartDate || moment().format("YYYY-MM-DD")),
      (this.end_date = this.curEndDate || moment().format("YYYY-MM-DD")),
      this.getPositions();
  },
  beforeDestroy() {},
  watch: {
    start_date(val) {
      this.startDateFormatted = this.formatDate(val);
    },
    end_date(val) {
      this.endDateFormatted = this.formatDate(val);
    },
  },
  computed: {
    ...mapState([
      "curDeviceId",
      "curDeviceName",
      "curTrainNo",
      "curTrainDate",
      "curOrg",
      "curArr",
      "curActArr",
      "curDest",
      "curDep",
      "curActDep",
      "curPosStartId",
      "curPosDestId",
      "curStartTime",
      "curEndTime",
      "curPositions",
    ]),
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
    },
    ...mapActions([
      "updateCurDeviceId",
      "updateCurDeviceName",
      "updateCurTrainNo",
      "updateCurTrainDate",
      "updateCurOrg",
      "updateCurArr",
      "updateActArr",
      "updateCurDest",
      "updateCurDep",
      "updateActDep",
      "updateCurPosStartId",
      "updateCurPosDestId",
      ,
      "updateCurStartTime",
      "updateCurEndTime",
      "updateCurPositions",
    ]),
    onRowClick($event) {
      //  console.log($event);
    },
    clear() {},
    getPositions() {
      var p = {
        start_train_date: this.start_date,
        end_train_date: this.end_date,
        pf_enter_speed: this.pf_enter_speed,
        pf_distance_min: this.pf_distance_min,
        pf_distance_max: this.pf_distance_max,
      };
      console.log(p);
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/timetable/tc/ctr_high_pf_enter_speed`,
          {
            params: p,
          }
        )
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },

    getFormattedTime(t) {
      if (t !== "--") {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment(lt);
        //  var localDate = moment(testDateUtc).local();
        return testDateUtc.format("HH:mm:ss");
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY");
    },
    createPDF() {
      const doc = new jsPDF({ orientation: "landscape", format: "a4" });
      var totalPagesExp = "{total_pages_count_string}";
      let rows = [];
      var that = this;
      var cnt = 1;
      this.positions.forEach((e) => {
        var temp = [
          cnt++,
          e["train_no"],
          e["org"],
          this.getFormattedTime(e["dep"]),
          e["dest"],
          this.getFormattedTime(e["arr"]),
          e["stn_code"],
          e["act_arr"],
          e["pf_enter_speed"],
          e["pf_distance"],
          e["name"]
            ? e["name"] + " (" + e["s_org"] + " - " + e["s_dest"] + ")"
            : "",
          e["Name"],
        ];
        rows.push(temp);
      });
      // Or use javascript directly:
      var pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.autoTable({
        theme: "plain",
        styles: {
          // Defaul style
          lineWidth: 0.01,
          lineColor: 0,
          fillStyle: "DF",
          halign: "center",
          valign: "bottom",
          cellWidth: "auto",
          overflow: "linebreak",
        },
        head: [
          [
            { content: "Srl No", rowSpan: 1 },
            { content: "Train No", rowSpan: 1 },
            { content: "Org" },
            { content: "Dep", colSpan: 1 },
            { content: "Dest", rowSpan: 1 },
            { content: "Arr", rowSpan: 1 },
            { content: "Stn Code", rowSpan: 1 },
            { content: "Stop Time" },
            { content: "PF Enter Speed", colSpan: 1 },
            { content: "PF Length", rowSpan: 1 },
            { content: "Crew Name (Section Worked)", colSpan:1  },
            { content: "Concerned CLI", colSpan: 1 },
          ],
        ],
        body: rows,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(14);
          doc.setTextColor(40);
          doc.text("EASTERN RAILWAY", pageWidth / 2, 10, "center");
          doc.setFontSize(12);
          doc.text(
            "ELECTRIC OPERATION DEPARTMENT,Sealdah",
            pageWidth / 2,
            16,
            "center"
          );
          doc.setFontSize(10);
          doc.text(
            "PLATFORM ENTER SPEED VIOLATION REPORT (Auto generated through SSTS)",
            pageWidth / 2,
            20,
            "center"
          );
          doc.text(
            "Period from :" +
              that.getFormattedDate(that.start_date) +
              " To: " +
              that.getFormattedDate(that.end_date),
            pageWidth / 2,
            24,
            "center"
          );

          // Footer
          // var str = 'Page ' + doc.internal.getNumberOfPages()
          // // Total page number plugin only available in jspdf v1.0+
          // if (typeof doc.putTotalPages === 'function') {
          //   str = str + ' of ' + totalPagesExp
          // }
          // doc.setFontSize(10)
          //
          // // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          // var pageSize = doc.internal.pageSize
          // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          // doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        margin: { top: 30 },
      });
      doc.setProperties({
        title: "PLATFORM ENTER SPEED VIOLATION REPORT",
      });
      doc.output("dataurlnewwindow");
    },
    createCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      var filename =
        "pf-enter-speed violation" +
        "-" +
        this.start_date +
        "-" +
        this.end_date +
        ".csv";
      var ctr = [];
      ctr.push({
        srl_no: "Platform Enter Speed Violation Report",
        Dest: "Period " + this.start_date + "-" + this.end_date,
      });
      for (var i = 0; i < this.positions.length; i++) {
        ctr.push({
          srl_no: i+1,
          train_no: this.positions[i]["train_no"],
          Org: this.positions[i]["org"],
          Dep: this.getFormattedTime(this.positions[i]["dep"]),
          Dest: this.positions[i]["dest"],
          Arr: this.getFormattedTime(this.positions[i]["arr"]),
          stn_code: this.positions[i]["stn_code"],
          StopTime: this.positions[i]["act_arr"],
          pf_enter_speed: this.positions[i]["pf_enter_speed"],
          pf_distance: this.positions[i]["pf_distance"],
          crew: this.positions[i]["name"]
            ? this.positions[i]["name"] +
              " (" +
              this.positions[i]["s_org"] +
              " - " +
              this.positions[i]["s_dest"] +
              ")"
            : "",
          CLI: this.positions[i]["Name"],
        });
      }
      jsonexport(ctr, function (err, csv) {
        if (err) return console.log(err);
        //console.log(csv);
        var blob = new Blob([csv], {
          type: "data:text/csv;charset=utf-8,",
        });
        saveAs(blob, filename);
      });
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
  },
};
</script>
